<template>
  <el-dialog
    title="订单详情"
    :visible="visible"
    width="900px"
    append-to-body
    top="8vh"
    destroy-on-close
    v-el-dialog-drag
    show-close
    :close-on-click-modal="false"
    :before-close="() => close()"
    :fullscree="fullscreen"
  >
    <DetailIndex :orderNo="orderNo" />
    <span slot="footer">
      <el-button size="small" @click="close()">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import DetailIndex from './index'
export default {
  components: { DetailIndex },
  props: {
    orderNo: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: true },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow: hidden !important;
}
</style>
